module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_3016.0da2976a.png";